import { Router } from '@angular/router';
import { CustomApplication } from 'src/app/CustomApplication';

export class BasePage {

    savedInstance = false
    defaultHref = "/navigation/home"
    
    constructor(
        public router: Router) {}

    openPage(page, data: Object = null) {
        this.router.navigate([page], {queryParams: data})
    }

    static openPage(page, data: Object = null) {
        CustomApplication.instanceRoute.navigate([page], {queryParams: data})
    }

    openPageByUrl(page, extras: Object = null) {
        this.router.navigateByUrl(page, extras);
    }

    openBack() {
        
    }
    
    encodeData(data: Object) {
        return btoa(JSON.stringify(data))
    }

    decodeData(data: string) {
        try {
            return JSON.parse(atob(data))
        } catch (e) {
            return {}
        }
    }

    ngOnInit() {
        this.savedInstance = true
    }

    ionViewDidLeave() {
        this.savedInstance = false
    }
}
